import Async from './util/Async';
import { h } from 'preact';
import { getContent } from '../routes';
import PropTypes from 'prop-types';
import store from '../store';
import UserAuth from './UserAuth';

function App(props) {
  let { route, user } = props;

  if (!user) {
    return <UserAuth />;
  }

  return <Async promise={getContent(route.path)} />;
}

App.propTypes = {
  route: PropTypes.object.isRequired,
  user: PropTypes.object.isRequired,
};

export default store.connect(App, {
  alerts: 'alerts',
  route: 'ui.route',
  user: 'user',
});
